import { MarkdownProps } from '@react-email/components'

export const MarkdownStyles: MarkdownProps['markdownCustomStyles'] = {
  h1: { fontSize: '24px', fontWeight: 600, margin: '16px 0px 8px 0px' },
  h2: { fontSize: '22px', fontWeight: 600, margin: '16px 0px 8px 0px' },
  h3: { fontSize: '20px', fontWeight: 600, margin: '16px 0px 8px 0px' },
  h4: { fontSize: '18px', fontWeight: 600, margin: '12px 0px 4px 0px' },
  h5: { fontSize: '16px', fontWeight: 600, margin: '12px 0px 4px 0px' },
  h6: { fontSize: '14px', fontWeight: 600, margin: '12px 0px 4px 0px' },
  codeBlock: { background: 'transparent' },
  p: {
    padding: '6px 0px',
  },
  ul: {
    padding: '8px 0px 8px 20px',
  },
  ol: {
    padding: '8px 0px 8px 20px',
  },
}
